module.exports = __webpack_public_path__ + "img/two-column-list-help.0522ae59.png";